import { ADD_AGENT } from '../../endpoints';
import { IAgent } from '../../types/agent';
import makeAuthenticatedRequest from '../base-api';

const addAgentApi = async (payload: IAgent) => {
  try {
    const response = await makeAuthenticatedRequest(ADD_AGENT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!response.ok) {
      if (result.message) {
        throw new Error(result.message);
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    }

    return result;
  } catch (error) {
    console.error('Add agent failed:', error);
    throw error;
  }
};

export { addAgentApi };
